<template>
  <v-form ref="formRotasPercorridas" @submit.prevent v-model="validRotasPercorridas">
    <v-container class="pt-0 telaRotas">
      <div class="header-step">
        <h3>Rotas Percorridas</h3>
        <p>Informe as rotas que costuma percorrer e com que frequência as realiza.</p>
      </div>
      <v-container grid-list-lg class="pl-0">
        <v-layout row wrap>
          <v-flex xs12 v-if="rotasPercorridasFormatado.length === 0">
            <small class="error--text">Informe ao menos uma rota</small>
          </v-flex>
          <v-flex xs12 v-else-if="totalFrequencia(rotasPercorridasFormatado) < 100">
            <small class="error--text">A soma dos percentuais não é de 100%"</small>
          </v-flex>
          <v-flex xs12 sm3>
            <v-autocomplete
              :disabled="desabilitaBotao(rotasPercorridasFormatado)"
              v-model="modelRotasPercorridas.estadoOrigem"
              label="Estado de origem"
              :items="listaEstados"
              @blur="carregaEstados(dadosEndereco.uf)"
              no-data-text="Sem estados para listar"
              browser-autocomplete="off"
              item-text="sigla"
              return-object
              :error-messages="errorMessages.txtOrigemRota"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm3>
            <v-autocomplete
              :disabled="desabilitaBotao(rotasPercorridasFormatado)"
              v-model="modelRotasPercorridas.estadoDestino"
              label="Estado de destino"
              :items="listaEstados"
              @blur="carregaEstados(dadosEnderecoDestino.uf)"
              no-data-text="Sem estados para listar"
              browser-autocomplete="off"
              item-text="sigla"
              return-object
              :error-messages="errorMessages.txtDestinoRota"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm3>
            <v-text-field
              :disabled="desabilitaBotao(rotasPercorridasFormatado)"
              v-model.lazy="modelFormatado.percentualRotaMaiorFrequencia"
              label="Frequência do percurso"
              type="number"
              min="0"
              max="100"
              :error-messages="errorMessages.txtPercentualRota"
              required
            >
            </v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 sm3 text-xs-left class="pl-0">
            <v-btn 
              :disabled="desabilitaBotao(rotasPercorridasFormatado)" 
              @click="adicionarRota"
              :block="$vuetify.breakpoint.xsOnly"
              class="white--text"
              color="secondary"
            >
              Adicionar
            </v-btn>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex>
            <span>Total: {{totalFrequencia(rotasPercorridasFormatado) ? totalFrequencia(rotasPercorridasFormatado) : 0}}/100%</span>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12>
            <v-data-table :headers="cabecalhoGridRotas"
            :items="rotasPercorridasFormatado"
            hide-actions
            no-data-text="Nenhuma rota foi adicionada">
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.estadoOrigem.sigla }}</td>
                <td class="text-xs-left">{{ props.item.estadoDestino.sigla }}</td>
                <td class="text-xs-left">{{ toPercentString(props.item.percentual) }}</td>
                <td><v-btn :disabled="disableRotasPercorridas" @click.stop="removeRota(props.item)" color="primary remove-rota" flat icon><v-icon>delete</v-icon></v-btn></td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs4 md3 class="pl-0">
            <v-btn
              flat
              @click="$emit('voltarRotasPercorridas', true)"
              color="primary"
            >
              Voltar
            </v-btn>
          </v-flex>
          <v-flex xs4 md3>
            <v-btn
              :disabled="!desabilitaBotao(rotasPercorridasFormatado)" 
              type="submit"
              @click="sendDatatoParent"
              color="primary"
            >
              proximo
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>
  </v-form>
</template>

<script>
import CustomFormat from '@/helpers/custom-format'
import axios from 'axios'

export default {
  name: "QARRotasPercorridas",
  props: {
    protocolo: String,
    dadosQuestionarioCompleto: {
      type: Object, 
      require: false
    }
  },
  data : () => ({
    validRotasPercorridas: true,
    listaEstados: [],
    validEndereco: true,
    dadosEndereco: {
      cep: null,
      endereco: [{
        id: 0,
        uf: "",
      pais: "",
      cidade: "",
      }] ,
    },
    dadosEnderecoDestino: {
      cep: null,
      endereco: [{
        id: 0,
        uf: "",
      pais: "",
      cidade: "",
      }] ,
    },
    rotasPercorridas: [],
    rotasPercorridasFormatado: [],
    modelRotasPercorridas: {
      estadoDestino: {},
      estadoOrigem: {},
      percentual: 0
    },
    errorMessages: {
      txtOrigemRota: [],
      txtDestinoRota: [],
      txtPercentualRota: []
    },
    cabecalhoGridRotas: [
      {text: 'Estado de Origem', value: 'estadoOrigem'},
      {text: 'Estado de Destino', value: 'estadoDestino'},
      {text: 'Frequência do percurso', value: 'percentual'},
      {text: '', value: ''}
    ],
    modelFormatado: {
      percentualRotaMaiorFrequencia: 0,
    }
  }),
  
  watch: {
    dadosQuestionarioCompleto(val) {
      var estadoOrigem = {}
      var estadoDestino = {}
      if(val.id != null && val.id != undefined) {
        for(var rota of val.dadosOperacionais.rotas) {
          for (var estado of this.listaEstados) {
            if (rota.idEstadoOrigem === estado.id) {
              estadoOrigem = estado
            }
            if (rota.idEstadoDestino === estado.id) {
              estadoDestino = estado
            }
          }
          this.rotasPercorridasFormatado.push({
            estadoOrigem: estadoOrigem,
            estadoDestino: estadoDestino,
            percentual: rota.percentual
          });
        }
      }
    },
    totalFrequencia: {
        handler: function () {
          this.totalFrequencia()
        },
        deep: true
      },
      'modelFormatado.percentualRotaMaiorFrequencia': function (val) { 
        this.modelRotasPercorridas.percentual = CustomFormat.removePercentFormat(val);
    }
  },
  mounted: function() {
    this.carregaEstados();
  },
  computed: {
   
    disableRotasPercorridas() {
      return this.protocolo != null || this.dadosQuestionarioCompleto.id != null;
    }
  },
  methods: {
    carregaEstados: function() {
      const self = this;

       axios

        .get(`${process.env.URL_GEOMS}/v1/no-auth/buscaTodosEstadosSemDiversos`)

        .then(response => {
          self.listaEstados = response.data;
        })
    },
    sendDatatoParent() {
      for (var x of this.rotasPercorridasFormatado) {
        this.rotasPercorridas.push({
          idEstadoOrigem: x.estadoOrigem.id,
          idEstadoDestino: x.estadoDestino.id,
          percentual: x.percentual
        })    
      }  
      this.$emit("dadosRotasPercorridas", this.rotasPercorridas);
    },
    
    desabilitaBotao(rotasPercorridasFormatado) {
      let valorTotal = 
      rotasPercorridasFormatado.reduce((acc, cur) => acc + (parseInt(cur.percentual) || 0), 0);
      if(valorTotal == 100){
        return true
      }
      return false

    },
    somaPercentual: function (array) {
      if (array.length > 0) {
        let percentuais = array.map(x => { return x.percentual; });
        let soma = percentuais.reduce((a, b) => { return a + b });
        return soma;
      }
      return 0;
    },
    removeRota: function (item) {
      const index = this.rotasPercorridasFormatado.indexOf(item);
      this.rotasPercorridasFormatado.splice(index, 1);
    },
    limpaCamposRotas: function () {
      this.modelRotasPercorridas.estadoOrigem = {};
      this.modelRotasPercorridas.estadoDestino = {};
      let somaRotas = this.somaPercentual(this.rotasPercorridasFormatado);
      this.modelFormatado.percentualRotaMaiorFrequencia = (100 - somaRotas).toLocaleString('pt-BR');
    },
    adicionarRota() {
      if (this.validaAddRota()) {
        this.rotasPercorridasFormatado.push(Object.assign({}, this.modelRotasPercorridas));
        this.limpaCamposRotas();
      }
    },
    validaAddRota() {
      let erro = false;

      this.errorMessages.txtOrigemRota = [];
      if (Object.keys(this.modelRotasPercorridas.estadoOrigem).length === 0) {
        erro = erro || true;
        this.errorMessages.txtOrigemRota = ["Você não pode deixar este campo em branco"]
      }

      this.errorMessages.txtDestinoRota = [];
      if (Object.keys(this.modelRotasPercorridas.estadoDestino).length === 0) {
        erro = erro || true;
        this.errorMessages.txtDestinoRota = ["Você não pode deixar este campo em branco"]
      }

      this.errorMessages.txtPercentualRota = [];
      if (this.modelRotasPercorridas.percentual <= 0 || this.modelRotasPercorridas.percentual > 100) {
          erro = erro || true;
          this.errorMessages.txtPercentualRota = ["Você precisa informar um percentual válido"]
      } else if ( isNaN(this.modelRotasPercorridas.percentual) ) {
          erro = erro || true;
          this.errorMessages.txtPercentualRota = ["Você precisa informar um percentual válido"]
      } else if (this.somaPercentual(this.rotasPercorridasFormatado) + this.modelRotasPercorridas.percentual > 100) {
          erro = erro || true;
          this.errorMessages.txtPercentualRota = ["O percentual ultrapassa os 100 % com este valor"]
      }
      return !erro;
    },

    deleteRota (item) {
      const index = this.rotasPercorridasFormatado.indexOf(item);
      this.rotasPercorridasFormatado.splice(index, 1);
    },
    totalFrequencia(modelRotasPercorridas) { 
      return modelRotasPercorridas.reduce((acc, cur) => acc + (parseInt(cur.percentual) || 0), 0);
    },
    toPercentString: function (val) {
      return CustomFormat.toPercentString(val);
    }
  },
}
</script>
<style>
.telaRotas {
  margin-top: 32px !important;
}
.totalFrequencia{
  color: red;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/questionario-analise-riscos/steps/QARRotasPercorridas.vue